// extracted by mini-css-extract-plugin
export default {"tooltipOverlay":"Tooltip_tooltipOverlay__9AjKN","editTooltipOverlay":"Tooltip_editTooltipOverlay__TnQ79","tooltipInfo":"Tooltip_tooltipInfo__r+Ys2"};